module.exports = __webpack_public_path__ + "img/share-location-on-gb-whatsapp.426b1f1f.webp";